
export default function PortfolioHero() {
  return (
    <section className="relative pt-32 pb-20 bg-gradient-to-br from-primary via-[#4A6B58] to-primary overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-warm-200 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-6xl mx-auto px-6 lg:px-12 text-center">
        <div className="w-20 h-px bg-accent mx-auto mb-6"></div>
        <h1 className="text-6xl lg:text-7xl font-black text-white mb-6 font-serif leading-tight">
          我們相信<br />
          最好的證明就是改變
        </h1>
        <p className="text-xl text-white/90 max-w-2xl mx-auto">
          每一個案例，都是屋主生活品質的提升
        </p>
      </div>
    </section>
  );
}
